import React, { useState, useEffect } from 'react';
import { getMyProfile, updateMyProfile } from '../../services/venueService';
import ZonePicker from '../shared/ZonePicker';

const ProfileForm = () => {
  const [profile, setProfile] = useState(null);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    getMyProfile().then(setProfile);
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      const updated = await updateMyProfile({
        businessName: profile.businessName,
        businessType: profile.businessType,
        address: profile.address,
        zone: profile.zone?._id || profile.zone
      });
      setProfile(updated);
      setMessage('Profile saved');
    } catch (err) {
      setMessage(err.response?.data?.message || 'Failed to save');
    } finally {
      setSaving(false);
    }
  };

  if (!profile) return <p>Loading...</p>;

  return (
    <form onSubmit={handleSave} className="space-y-4 bg-white p-6 rounded-lg shadow">
      <input value={profile.businessName} onChange={(e) => setProfile({ ...profile, businessName: e.target.value })}
        placeholder="Business name" className="w-full p-3 border rounded-lg" required />
      <select value={profile.businessType} onChange={(e) => setProfile({ ...profile, businessType: e.target.value })}
        className="w-full p-3 border rounded-lg">
        <option value="room_partner">Room partner</option>
        <option value="full_business">Full business</option>
        <option value="both">Both</option>
      </select>
      <input value={profile.address || ''} onChange={(e) => setProfile({ ...profile, address: e.target.value })}
        placeholder="Address" className="w-full p-3 border rounded-lg" />
      <div>
        <p className="text-sm font-medium mb-2">Zone</p>
        <ZonePicker
          mode="single"
          value={profile.zone?._id || profile.zone || ''}
          onChange={(zoneId) => setProfile({ ...profile, zone: zoneId })}
        />
      </div>
      {message && <p className="text-sm text-green-600">{message}</p>}
      <button type="submit" disabled={saving}
        className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 disabled:opacity-50">
        {saving ? 'Saving...' : 'Save profile'}
      </button>
    </form>
  );
};

export default ProfileForm;
